import React, { useEffect } from 'react';
import { useLocation, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import SessionTimeOutConnectLazy from 'yoda-account-components/lib/components/SessionTimeOut/SessionTimeOutConnectLazy';
import PasswordResetConnectLazy from 'yoda-account-components/lib/components/PasswordReset/Page/PasswordResetConnectLazy';
import CreateAccountConnectLazy from 'yoda-account-components/lib/components/CreateAccount/Page/CreateAccountConnectLazy';
import SignInConnectLazy from 'yoda-account-components/lib/components/Login/Page/SignInConnectLazy';
import CAMDashboard from './containers/Pages/CAMDashboard/CAMDashboardConnectLazy';
import CustomerInformationConnectLazy from './containers/Pages/CustomerInformation/CustomerInformationConnectLazy';
import PromoSMSEmailConnectLazy from './containers/Pages/PromoSMSEmail/PromoSMSEmailConnectLazy';

/* istanbul ignore next */
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

/* istanbul ignore next */
export default () => (
    <>
        <ScrollToTop />
        <Switch>
            {/* redirects first */}
            <Redirect
                exact
                from="/account/dashboard/payment-methods"
                to="/account/dashboard/wallet"
            />
            <Redirect
                exact
                from="/account/dashboard/profile/settings"
                to="/account/dashboard/personal/info"
            />
            <Redirect
                exact
                from="/account/dashboard/profile/email"
                to="/account/dashboard/personal/info"
            />
            <Redirect
                exact
                from="/account/dashboard/address"
                to="/account/dashboard/personal/info"
            />

            {/* then all the routes */}
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Route exact path="/signin" render={(props) => <SignInConnectLazy {...props} />} />
            <Route exact path="/createaccount" render={() => <CreateAccountConnectLazy />} />
            <Route
                exact
                path="/forgotpassword"
                // eslint-disable-next-line react/jsx-props-no-spreading
                render={(props) => <PasswordResetConnectLazy {...props} />}
            />
            <Route exact path="/sessiontimeout" render={() => <SessionTimeOutConnectLazy />} />
            <Route exact path="/ccpa-dsr" render={() => <CustomerInformationConnectLazy />} />
            <Route exact path="/promotionalsignup" render={() => <PromoSMSEmailConnectLazy />} />
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Route exact path="/account/*" render={(props) => <CAMDashboard {...props} />} />

            {/* then error handling */}
            <Route component={NotFound} />
        </Switch>
    </>
);
